import { SweepEvent } from '../../spline/coneSpanner/SweepEvent';
export class AxisEdgeHighPointEvent extends SweepEvent {
    constructor(edge, point) {
        super();
        this.site = point;
        this.AxisEdge = edge;
    }
    get Site() {
        return this.site;
    }
}
//# sourceMappingURL=AxisEdgeHighPointEvent.js.map